import { object, string } from "yup";

export const validateSchema = object().shape({
  email: string().email("Must be a valid email").max(255).required("Email is required")
});
